/**
 * @flow
 * @author: Chinmaya
 */
export default {
  borderRadius: '50%',
  borderColor: 'red',

  // Header landing section
  headerTextColor: 'white',
  // Button constants
  buttonTextColor: 'white',
  buttonBorderRadius: '4px',
  filledButtonBGColor: '#19c7ff',
  filledButtonTextColor: 'white',
  filledTransparentBorder: 'transparent',
  transparentButtonTextColor: 'white',
  transparentButtonBGColor: 'rgba(255, 255, 255, 0.1)',
  transparentButtonBorder: 'rgba(255, 255, 255, 0.4);',
  landing: {
    servicesBackgroundColor: 'rgba(0,0,0,0.3)'
  },
  // poweredby
  poweredby: {
    poweredByTextColor: '#43484d',
    poweredbyBackgroundColor: '#ffffff',
    poweredbyDivider: '1px solid #d7e3f3',
    backgroundColor: '#ffffff'
  },
  poweredbyteam: {
    poweredByTextColor: '#43484d',
    poweredbyBackgroundColor: '#ffffff',
    poweredbyDivider: '1px solid #d7e3f3',
    backgroundColor: '#ffffff'
  },
  navbar: {
    lightBGColor: 'transparent',
    darkBGColor: 'white',
    navTextColor: '#fff',
    transparentNavTextColor: '#43484c',
    bgColor: '#fff',
    transparantBgColor: 'transparent'
  },

  // Testimonials section
  testimonials: {
    background: 'transparent',
    imageBorderRadius: '6px',
    titleColor: '#ffffff',
    contentTextColor: 'white',
    nameColor: 'white'
  },

  // iB Cricket product launching section
  productLaunch: {
    textColor: 'white',
    gradientBGStartColor: '#003683',
    gradientBGEndColor: '#002e87'
  },

  launchingInfo: {
    imageBorderRadius: '50%',
    headingTextColor: '#0d1921',
    descriptionColor: '#5b626e',
    linkButtonTextColor: '#163878'
  },

  followUsSection: {
    headingTextColor: '#0d1921',
    subHeadingTextColor: '#5b626e',
    descriptionTextColor: '#5b626e',
    linkButtonTextColor: '#163878'
  },

  // Blog Template Styles

  blogTemplate: {
    primaryTextColor: '#0d1921',
    secondaryTextColor: '#43484c',
    dividerColor: '#d7e3f3'
  },
  footerSection: {
    background: `#122445`,
    inputBackground: `rgba(255, 255, 255, 0.1)`,
    inputText: `#868e9d`,
    lightTextColor: `#868e9d`,
    filledButtonBGColor: '#19c7ff',
    pageLinksColor: `#ffffff`,
    poweredByTextColor: '#43484d',
    poweredbyBackgroundColor: '#ffffff',
    poweredbyDivider: 'none',
    white: `#ffffff`
  },
  applicationSection: {
    background: 'white',
    titleColor: 'black'
  }
}
